import type {
  OrganizationEntities,
  SingleAccountEntities,
  Account,
  Organization
} from '@src/redux/reducers/auth/models'
import type { State } from '@src/redux/configureStore'
import type { ResourceTypeDict } from '@src/redux/reducers/shell'
import { createSelector } from 'reselect'
import { filter, map } from 'lodash'

export const getLastUpdate = (state: State) => state.auth.tenant.update_time

export const getResourceTypes = (state: State) =>
  (state.shell.resourceTypes || {}) as ResourceTypeDict

export const getCurrentAccount = (state: State) => state.filter?.currentAccount

export const getCurrentAccountID = createSelector(
  [getCurrentAccount],
  account => account?.id
)

export const getOnboardedOrganizationEntities = (state: State) =>
  state.auth.organizations || {
    entities: {} as OrganizationEntities,
    organizationUIDs: [] as string[]
  }

export const getSelectedPolicy = (state: State) => state.policies.selectedPolicy

export const getAccounts = (state: State) =>
  state.auth.tenant.account_info || []

export const getTenant = (state: State) => state.auth.tenant
export const getTenantID = (state: State) => state?.auth?.tenant?.tenant_id
export const isLoggedIn = (state: State) => state.auth.isLoggedIn
export const isLoggedOut = (state: State) => state.auth.isLoggedOut

export const getOnboardedSingleAccountsEntities = (state: State) =>
  state.auth.singleAccounts || {
    entities: {} as SingleAccountEntities,
    accountUIDs: [] as string[]
  }

export const getOrganization = (state: State) =>
  state.auth.tenant.organization_info || []

export const getTexBoxTooltipFixFlag = (state: State) =>
  state.shell.useTexBoxTooltipFix

/**
 * @description
 * It is selector.
 * Returns all accounts list that do not belong to any organization (single accounts)
 * @returns array
 */
export const getOnboardedAccountListSelector = createSelector(
  [getOnboardedSingleAccountsEntities],
  ({ entities = {} as SingleAccountEntities, accountUIDs = [] }): Account[] =>
    filter(
      map<string, Account>(accountUIDs, id => entities.accounts[id]),
      acc => !acc.is_organization_account
    )
)

/**
 * @description
 * It is selector.
 * Returns all organization list
 * @returns array
 */
export const getOnboardedOrganizationListSelector = createSelector(
  [getOnboardedOrganizationEntities],
  ({
    entities = {} as OrganizationEntities,
    organizationUIDs = []
  }): Organization[] =>
    map<string, Organization>(
      organizationUIDs,
      uid => entities.organizations[uid]
    )
)

export const getUser = (state: State) => state.auth?.user

export const getAccountInfo = (state: State) => state.auth?.tenant?.account_info
export const getUseChangesPage = (state: State) => state.changes?.useChangesPage
export const getUseIDNLoginPage = (state: State) => state.shell?.useIDNLoginPath
export const getIdnAPIURL = (state: State) => state.auth?.idnAPIUrl
